import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Flame } from 'lucide-react';
import { Button } from '../ui/button';
import SmsCoachButton from '../shared/SmsCoachButton';
import { offSeasonTraining } from '../../mock';

const SECTION_STYLE = {
  background:
    'linear-gradient(90deg, rgba(255,215,0,0.22), rgba(0,0,0,0.65) 30%, rgba(0,0,0,0.65) 70%, rgba(255,215,0,0.22))',
  backgroundColor: '#0a0a0a',
  borderTop: '1px solid rgba(255, 215, 0, 0.6)',
  borderBottom: '1px solid rgba(255, 215, 0, 0.6)',
  padding: '1.25rem 1rem',
  position: 'relative',
  overflow: 'hidden',
};

const CONTAINER_STYLE = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.6rem 1.5rem',
  textAlign: 'center',
  color: '#ffffff',
  position: 'relative',
  zIndex: 1,
};

const PILL_STYLE = {
  background: 'linear-gradient(90deg, #FFD700 0%, #FFC500 100%)',
  color: '#000',
  padding: '0.4rem 1rem',
  borderRadius: '999px',
  fontWeight: 900,
  fontSize: '0.78rem',
  letterSpacing: '1.5px',
  whiteSpace: 'nowrap',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.35rem',
  boxShadow: '0 4px 16px rgba(255, 215, 0, 0.4)',
};

const OffSeasonBanner = () => (
  <section
    className="ota-announcement-banner"
    data-testid="ota-announcement-banner"
    style={SECTION_STYLE}
  >
    <div className="container" style={CONTAINER_STYLE}>
      <span style={PILL_STYLE} data-testid="ota-banner-pill">
        <Flame size={14} /> ACTIVELY RECRUITING
      </span>
      <span style={{ fontSize: '1rem', fontWeight: 500, lineHeight: 1.45, color: '#ffffff' }}>
        <strong style={{ color: '#FFD700' }}>Practice is in full swing for all age groups</strong>
        {' — '}every{' '}
        <strong style={{ color: '#ffffff' }}>{offSeasonTraining.schedule.days}, {offSeasonTraining.schedule.time}</strong>
        {' '}at{' '}
        <strong style={{ color: '#ffffff' }}>{offSeasonTraining.location.name}</strong>.
        <br />
        <span style={{ color: '#FFD700', fontSize: '0.9rem', fontWeight: 700 }}>
          {offSeasonTraining.ageGroups} · New athletes welcome any weekday
        </span>
      </span>
      <Link to="/training" style={{ textDecoration: 'none' }}>
        <Button
          className="btn-primary"
          style={{ padding: '0.45rem 1.1rem', fontSize: '0.9rem', fontWeight: 700 }}
          data-testid="ota-banner-details-btn"
        >
          Join a Practice <ChevronRight size={16} />
        </Button>
      </Link>
      {offSeasonTraining.smsContact && (
        <SmsCoachButton
          phone={offSeasonTraining.smsContact.phone}
          message={offSeasonTraining.smsContact.prefilledMessage}
          label={`Text ${offSeasonTraining.smsContact.coachName}`}
          testId="ota-banner-sms-btn"
          variant="ghost"
        />
      )}
    </div>
  </section>
);

export default OffSeasonBanner;
